import React from 'react';
import { Container, Dot, Text } from './StackProgress.styled';

/**
 * StackProgress - Current step description with pulsing dot.
 */
const StackProgress = ({ activity }) => {
  if (!activity) return null;

  const label = activity.label ?? activity.description ?? 'Processing...';

  return (
    <Container>
      <Dot aria-hidden />
      <Text>{label}</Text>
    </Container>
  );
};

export default StackProgress;
